import { Outlet } from 'react-router';

export function RootLayout() {
  return (
    <>
      <header className="app-header">
        <h1 className="app-title">
          <img src="/campfire.png" alt="Campfire" className="fire-icon" />
          makewith.you
        </h1>
      </header>
      <Outlet />
    </>
  );
}
